/* global _TL_ */
/* eslint-disable no-bitwise */
/*eslint new-cap:0 */
import pageContext from '@bingads-webui-static-legacy/page-context';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import Promise from 'bluebird';
import summaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import { Repository } from '@bingads-webui-campaign-legacy/adextension-image/service/repository';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import uiBlocker from '@bingads-webui-component-legacy/uiblocker/index';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import * as scrollUtil from '@bingads-webui-component-legacy/extension/scrollTo';
import AppEventDelegator from '@bingads-webui-component-legacy/app-event-delegator/index';
import ViewModel from '@bingads-webui-campaign-legacy/adgroup-create-advanced/viewmodel/index';
import containerTemplate from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/container.pug';
import noCampaignTemplate from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/noCampaignPage.pug';
import template from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/index.pug';
import SettingsView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/steps/settings';
import AdsView from '@bingads-webui-campaign-legacy/crud-ad/view/adsPanel';
import KeywordsView from '@bingads-webui-campaign-legacy/crud-keywords/view/section-wrapper';
import biddingStrategyTypes from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';
import BidView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/steps/bid';
import campaignType from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import LanguageLocationConnector from '@bingads-webui-campaign-legacy/adgroup-create-advanced/connectors/languageLocation';
import AdgroupKeywordConnector from '@bingads-webui-campaign-legacy/adgroup-create-advanced/connectors/adgroupKeyword';
import AutoTargetBidConnector from '@bingads-webui-campaign-legacy/adgroup-create-advanced/connectors/autoTargetBid';
import CpgBidOptionConnector from '@bingads-webui-campaign-legacy/adgroup-create-advanced/connectors/cpg-bid-option';
import CpgAdGroupTypeInHouseConnector from '@bingads-webui-campaign-legacy/adgroup-create-advanced/connectors/cpgAdGroupTypeInHouse';
import BidStrategyBidOptionConnector from '@bingads-webui-campaign-legacy/adgroup-create-advanced/connectors/bidstrategy-bidoption';
import { getDailyBudgetAmount } from '@bingads-webui-campaign-legacy/budget/shared/formatter';
import AdvancedSettingsView from '@bingads-webui-campaign-legacy/advanced-settings/view/advancedSettings';
import LocationTargetsView from '@bingads-webui-campaign-legacy/location-targets/view/locationTargets';
import AutoTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/create/index';
import { syndEnum } from '@bingads-webui-campaign-react/constants';
import CpgBidSection from '@bingads-webui-campaign-legacy/shopping-campaign/view/cpg-adgroup/bid-section';
import showCpgAdGroupType from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/showCpgAdGroupType';
import AdGroupTargetsView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/adgroup-targets';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { logBidAdoption } from '@bingads-webui-campaign-legacy/budget/shared/log';
import { shouldSupportCashbackSettings, logAdGroupPersonalizedOffers } from '@bingads-webui-campaign/personalized-offer-shared';
import physicalIntentOptions from '@bingads-webui-campaign-legacy/location-targets/viewmodel/physicalIntentOptions';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { defaultBid, defaultMSStoreSuggestionBid } from '@bingads-webui-campaign-legacy/budget/shared/defaultBid';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import { isMSStoreAdsCampaign } from '@bingads-webui-campaign-react/ms-store-ads-common';
import { AssetChannel, AssetScenario } from '@bingads-webui-react/copilot-event-provider';
import {
  POST_ASSET_EVENT_NAME,
  AssetEventFeature,
  AssetEventRecordType,
  AssetEventOperationName,
} from '@bingads-webui-campaign-react/copilot-common';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const activity = instrumentation.suggestionInCreationWorkflow.create().adGroupCreation.create();

const campaignType2sectionMap = () => {
  return {
    'search': ['ad', 'keyword', 'bid', 'advanced-settings', 'location-targets', 'adgroup-targets'],
    'shopping': ['advanced-settings', 'location-targets']
      .concat([showCpgAdGroupType() ? 'cpgBidSection' : 'bid'])
      .concat(['adgroup-targets']),
    'dynamicSearch': ['auto-targets', 'ad', 'bid', 'advanced-settings', 'adgroup-targets'],
  };
};

const removeBidView = (campaign, section) => {
  if (_.chain(campaign).result('BiddingScheme').result('Type').value() === biddingStrategyTypes.costPerSale) {
    return section.filter((sec) => sec !== 'bid');
  }
  return section;
};

const permissions = config.get('Permissions') || {};
const isSponsoredPilotEnabled = Boolean(_.result(permissions, 'IsSPAv2Enabled', false));
const isDSAMixedModeCampaignEnabled = _.result(permissions, 'IsDSAMixedModeCampaignEnabled', false);

const AdGroupLogId = uuid.v4();

function isMSStoreAdsGAWorkflow() {
  const campaign = config.get('CurrentCampaign');
  const result = isMSStoreAdsCampaign(campaign);

  return result;
}

const section2subViewMap = {
  'ad': {
    viewFactory: AdsView,
    options: ({ context, serverContext }) => {
      return {
        newI18n: context.options.deps && context.options.deps.i18nNewDesign,
        language: context.settings.viewModel.Language(),
        perfMarker: context.perfMarker,
        usePanel: context.usePanel,
        isForVNext: context.isForVNext,
        Campaign: context.campaign,
        adGroupType: context.adGroupType,
        serverContext,
      };
    },
  },
  'keyword': {
    viewFactory: KeywordsView,
    options: (parentContext) => {
      const context = new Backbone.Model();

      context.set({ 'Campaign': config.get('CurrentCampaign') });
      return {
        showOnlyKeywords: true,
        context,
        scenario: 'ad group creation',
        perfMarker: parentContext.context && parentContext.context.perfMarker,
      };
    },
  },
  'bid': {
    viewFactory: BidView,
    options: ({ campaign, context }) => {
      const defaultBidValue = isMSStoreAdsGAWorkflow() ? defaultMSStoreSuggestionBid() : null;

      return {
        newI18n: context.options.deps && context.options.deps.i18nNewDesign,
        languages: _.isEmpty(campaign.Languages) ? [context.settings.viewModel.Language()] : campaign.Languages,
        showTrafficEstimation: campaignType() === 'search' && !context.options.isDynamicAdGroupCreation,
        budget: getDailyBudgetAmount(campaign.Budget),
        getKeywordsCb: () => {
          if (context.subViews.keyword) {
            return context.subViews.keyword.getCurKeywords();
          }
          return [];
        },
        campaign,
        perfMarker: context.perfMarker,
        isForVNext: context.isForVNext,
        bidStatusEnabled: true,
        activityLogger: context.activity,
        AdGroupLogId,
        defaultBidValue,
      };
    },
  },
  'cpgBidSection': {
    viewFactory: CpgBidSection,
  },
  'advanced-settings': {
    viewFactory: AdvancedSettingsView,
    options: ({ campaign, context }) => {
      const isSPB = campaign.CampaignCashback && campaign.CampaignCashback.IsPromotionsForBrands;
      let model = {
        AdScheduleTimeZoneSetting: campaign.AdScheduleTimeZoneSetting,
        AdScheduleUseSearcherTimeZone: campaign.AdScheduleUseSearcherTimeZone,
      };

      if (campaignType() === 'shopping' && campaign.CampaignSubType === 'ShoppingSponsoredProductAd' && !isSPB) {
        // todo： better to get this from the import { getDefaultAdDistribution } from '@bingads-webui-campaign-react/sponsored-campaign-creation';
        // need to fix some build error then.
        model.AdDistribution = 'InHousePromotion';
      }
      return {
        model,
        perfMarker: context.perfMarker,
        campaignId: config.get('CurrentCampaign').Id,
        campaignAdScheduleUseSearcherTimeZone: campaign.AdScheduleUseSearcherTimeZone,
        adgropuId: '',
        level: 'adgroup',
        scenario: 'adgroup-create',
        nativeAdsCampaignBid: campaign.NativeBidAdjustment,
        multimediaAdsCampaignBid: campaign.MultiMediaAdBidAdjustment,
        TimeZone: campaign.TimeZone,
        campaignType: campaignType(),
        campaignSubType: campaign.CampaignSubType,
        language: context.settings.viewModel.Language(),
        languages: _.isEmpty(campaign.Languages) ? [context.settings.viewModel.Language()] : campaign.Languages,
        supportCashbackSettings: context.showCashbackSettings,
        isSPBCampaign: isSPB,
        isMSStoreAdsGAWorkflow: isMSStoreAdsGAWorkflow(),
        popupIds: isMSStoreAdsGAWorkflow() ? {
          AdDistribution: 'pop_BA_StoreAds_AdDistribution',
        } : undefined,
      };
    },
  },
  'location-targets': {
    viewFactory: LocationTargetsView,
    options: ({ context }) => {
      const campaign = config.get('CurrentCampaign');
      const isWindowsStoreAd = isMSStoreAdsGAWorkflow();

      return {
        campaignId: campaign.Id,
        adgroupId: '',
        level: 'campaign', //level is set to campaign, so the control opens up with the campaign data and the 'use campaign settings' checkbox checked
        scenario: 'adgroup-create',
        popupIds: { Location: isMSStoreAdsGAWorkflow() ? 'pop_BA_StoreAds_Location' : 'pop_BA_AdGroup_LocationTargeting' },
        perfMarker: context.perfMarker,
        supportCashbackSettings: context.showCashbackSettings,
        deps: {
          eventDelegator: context.eventDelegator,
        },
        physicalIntent: isWindowsStoreAd ? physicalIntentOptions.PeopleIn : undefined,
        isForVNext: context.isForVNext,
        showPhysicalIntentView: !isWindowsStoreAd,
      };
    },
  },
  'auto-targets': {
    viewFactory: AutoTargetView,
    options: (args) => {
      let campaignSetting = _.chain(args)
        .result('campaign')
        .result('CampaignSettings')
        .first()
        .value() || {};

      return {
        showHeader: true,
        setting: campaignSetting,
      };
    },
  },
  'adgroup-targets': {
    viewFactory: AdGroupTargetsView,
    options: (options) => {
      return _.extend({}, options, {
        supportCashbackSettings: options.context.showCashbackSettings,
        isMSStoreAdsGAWorkflow: isMSStoreAdsGAWorkflow(),
      });
    },
  },
};

export default class View extends Backbone.View {
  initialize(options = {
    isDynamicAdGroupCreation: false,
    isMixedMode: false,
    getCampaignPromise: null,
  }) {
    if (options.perfMarker) {
      options.perfMarker.willInit();
      this.perfMarker = options.perfMarker;
    }


    this.isForVNext = options.isForVNext;
    this.usePanel = options.usePanel;
    this.adGroupType = options.adGroupType;
    this.isOpenCreatePanel = options.isOpenCreatePanel;
    this.serverContext = options.serverContext;
    const router = _.chain(options.deps).result('router', {}).value();

    this.navigateToRoute = router.navigateToRoute || _.noop;

    this.eventDelegator = _.result(options.deps, 'eventDelegator', new AppEventDelegator());

    const scenario = instrumentation[`${campaignType()}AdGroupCreation`].create();

    this.activity = scenario.adGroupCreation.create();
    this.activity.start();

    const inContextRepairRecScenario = instrumentation.inContextRepairRecommendation.create();

    this.applyActivity = inContextRepairRecScenario.applyDeliveryStatus.create();

    this.campaign = config.get('CurrentCampaign');

    const dynamicPermissions = _.result(pageContext.Permissions, 'dynamic', {});

    this.showDisclaimerBanner = _.result(dynamicPermissions, 'AgeGenderDisclaimer', false);

    if (this.campaign) {
      this.viewModel = new ViewModel();
      this.viewModel.isNextButtonEnabled =
        !(pageContext.Permissions.IsReadOnlyUser || pageContext.CurrentAccountInActive);

      // mock
      // this.campaign.CashbackSettings = { CashbackMonthlyBudget: 1 };

      const showCashbackSettings = shouldSupportCashbackSettings(this.campaign, permissions) && this.campaign.CampaignSubType == null;

      this.showCashbackSettings = showCashbackSettings;
      this.settings = new SettingsView({
        blockedElement: this.$el,
        isDynamicAdGroupCreation: this.options.isDynamicAdGroupCreation,
        showCashbackSettings,
      });
      this.settings.on('copy.adgroup', this.copyAdGroup.bind(this));

      //refreshing the intermediate location data when creating a new adgroup
      jsData.Intermediate.refresh('CampaignCriterion', [])
        .then(() => {
          jsData.Intermediate.refresh('AdGroupCriterion', []);
        });
    }

    this.logTrace({
      mes: 'Enter Ad Group Creation Flow',
      adGroupType: this.adGroupType || 'NoSpecified',
    });
  }

  isDynamicAdGroupCreation() {
    return this.options.isDynamicAdGroupCreation && campaignType() === 'search';
  }

  initializeSubViews(campaign = {}) {
    let sections = removeBidView(campaign, campaignType2sectionMap()[campaignType()]);

    if (this.isDynamicAdGroupCreation()) {
      sections = campaignType2sectionMap().dynamicSearch;
    }

    this.subViews = _.object(sections, _.map(sections, (section) => {
      return new section2subViewMap[section].viewFactory(_.isFunction(section2subViewMap[section].options) ? section2subViewMap[section].options({
        campaign,
        context: this,
        serverContext: this.serverContext,
      }) : section2subViewMap[section].options);
    }));

    /*LanguageLocationConnector is used for:
      1. Check synd options available or not. Synd options is enabled when selected location targetings + language are among the whitelist. No campaign type limitation
      2. Check whether KP and traffic estimation is enabled or not. enable condition:
        1) English language
        2) Search campaign
        3) Location targeting includes certain areas or target everywhere
    */
    if (this.subViews.bid && this.subViews['advanced-settings'] && this.subViews['advanced-settings'].adDistributionView) {
      this.languageLocationConnector = new LanguageLocationConnector(
        this.settings.viewModel.Language,
        this.subViews.bid,
        this.subViews['advanced-settings'].adDistributionView,
        this.subViews.keyword,
        true);

      if (!_.isEmpty(campaign.Languages)) {
        this.languageLocationConnector.setLanguageSet(campaign.Languages);
      }

      this.languageLocationConnector.onChange();

      if (campaignType() === 'search') {
        /*AdgroupKeywordConnector is used for updating traffic estimation when
          1) Adgroup name changes
          2) Keywords changes
        */
        this.adgroupKeywordConnector = new AdgroupKeywordConnector(
          this.settings.viewModel.Name,
          null,
          this.subViews.keyword,
          this.subViews.bid.searchBidView,
        );
      }
    }

    if (this.isDynamicAdGroupCreation() && this.subViews.bid) {
      this.autoTargetBidConnector = new AutoTargetBidConnector(this.subViews['auto-targets'], this.subViews.bid.searchBidView);
    }

    if (this.subViews.ad) {
      this.settings.on('update:language', (language) => {
        this.subViews.ad.updateLanguage(language);
      });

      // update keyword planner url after ads updated
      // only for adgroups that do have keyword subview
      if (this.subViews.keyword) {
        this.subViews.ad.on('ads:changed', () => {
          const ads = this.subViews.ad.getAds();

          if (ads.length > 0) {
            const displayUrlToUse = ads[ads.length - 1].displayUrl;

            this.subViews.keyword.onAdsUrlUpdated(displayUrlToUse);
          }
        });
      }
    }

    this.bindCashbackPercentChangeHandler();

    this.createCpgConnectors();
  }

  onCashbackPercentChange(value) {
    const formattedValue = value === '' || value == null ? null : decimal.fromLocalToFloat(value);
    const subViewsNeedToUpdate = _.compact([
      this.subViews['advanced-settings'] && this.subViews['advanced-settings'].adScheduleView,
      this.subViews['adgroup-targets'] && this.subViews['adgroup-targets'].childView,
      this.subViews['location-targets'],
    ]);

    subViewsNeedToUpdate.forEach((view) => {
      view.toggleCashbackPercentColumns(true, {
        level: 'AdGroup',
        value: formattedValue,
      });
    });
  }

  bindCashbackPercentChangeHandler() {
    if (this.settings && this.settings.subViews.cashbackSettings) {
      this.settings.subViews.cashbackSettings.viewModel.CashbackPercent.subscribe((v) => {
        if (this.settings.subViews.cashbackSettings.viewModel.validateCashbackPercent(v)) {
          this.onCashbackPercentChange(v);
        }
      });
    }
  }

  createCpgConnectors() {
    if (this.subViews.cpgBidSection) {
      // 1. In CPG pilot 2. current campaign is co-op campaign
      this.cpgBidOptionConnector = new CpgBidOptionConnector(this.settings.subViews.cpgAdGroupType, this.subViews.cpgBidSection);

      // In In-House pilot
      if (isSponsoredPilotEnabled && this.subViews['advanced-settings'] && this.subViews['advanced-settings'].adDistributionView) {
        this.cpgInHouseConnector = new CpgAdGroupTypeInHouseConnector(this.settings.subViews.cpgAdGroupType, this.subViews['advanced-settings'].adDistributionView);
      }
    }

    if (this.settings.subViews.cpgAdGroupType && this.settings.subViews.automatedBidding) {
      this.bidStrategyBidOptionConnector = new BidStrategyBidOptionConnector(this.settings.subViews.cpgAdGroupType, this.settings.subViews.automatedBidding);
    }
  }

  copyAdGroup([adGroup, adGroupCriterions]) {
    if (this.subViews['location-targets'] && !_.isEmpty(adGroupCriterions) && _.isArray(adGroupCriterions)) {
      const criterions = _.map(adGroupCriterions, (criterion) => {
        return _.omit(criterion, 'Id', 'AdGroup');
      });

      this.subViews['location-targets'].refreshLocationDataFromOtherAdGroup(criterions);
    }

    if (!_.isEmpty(adGroup)) {
      if (this.subViews.bid) {
        this.subViews.bid.setModel(adGroup);
      }

      if (this.settings && this.settings.subViews.cashbackSettings) {
        const CashbackPercent = _.chain(adGroup)
          .result('AdGroupCashback')
          .result('Percent')
          .value();
        const CashbackScope = _.chain(adGroup)
          .result('AdGroupCashback')
          .result('Scope')
          .value();
        const CouponsEnabled = _.chain(adGroup)
          .result('AdGroupCashback')
          .result('CouponsEnabled')
          .value();

        const cashbackSettings = {
          CashbackPercent,
          CashbackScope,
          CouponsEnabled,
        };

        this.settings.subViews.cashbackSettings.setValues(cashbackSettings);
      }
    }
  }

  get events() {
    return {
      'click .btn-save': 'save',
      'click .btn-cancel': 'cancel',
      'click .create-campaign': 'createCampaign',
    };
  }

  createCampaign() {
    this.navigateToRoute('campaign_create_objective');
  }

  render() {
    this.perfMarker.willRender();
    if (this.campaign) {
      const params = {
        queryParameters: {
          entitySet: edmCampaign.currentAccount.Campaigns,
          expand: ['Budget'],
        },
        bypassCache: true,
      };

      this.$el.append(containerTemplate());

      // the budget is only for traffic estimation and errors here does not block the creation, so no
      // error handling here.
      Promise.resolve(this.options.getCampaignPromise || jsData.Campaign.find(Number(this.campaign.Id), params))
        .then((data) => {
          this.initializeSubViews(data);

          this.$('.adgroup-create-page').append(template({
            i18n,
            subViews: this.subViews,
            isMixedMode: this.options.isMixedMode,
            isShowDisclaimerBannerEnabled: this.showDisclaimerBanner,
          }));
          ko.applyBindings(this.viewModel, this.el);

          this.$('.adgroup-settings').append(this.settings.render().el);

          _.each(this.subViews, (view, section) => {
            if ((section === 'location-targets') && this.subViews['adgroup-targets']) {
              // location targets will append later as a sub section of adgroup targets
              return;
            }

            this.$(`.${section}-section`).append(view.render().el);

            if (section === 'adgroup-targets' && this.subViews['location-targets']) {
              view.asyncTask.then(() => {
                view.$('.location-setting-controller').append(this.subViews['location-targets'].render().el);
              });
            }
          });

          if (this.settings.subViews.automatedBidding && this.subViews.bid) {
            this.subViews.bid.resetIsAutoBidding(this.settings.subViews.automatedBidding.getValues().Type);
            this.$('.bidding-strategy__container')[0].addEventListener('change', () => {
              this.subViews.bid.resetIsAutoBidding(this.settings.subViews.automatedBidding.getValues().Type);
            }, false);
          } else if (this.isDynamicAdGroupCreation() && _.isUndefined(this.settings.subViews.automatedBidding) && this.subViews.bid) {
            // DSA ad group doesn't have autobidding UI.
            this.subViews.bid.resetIsAutoBidding('InheritFromParent');
          }
        })
        .finally(uiBlocker(this.el))
        .then(() => {
          if (!this.options.isMixedMode) {
            this.$('input:first', this.$('.adgroup-settings')).focus();
          }
          this.perfMarker.done();
        });

    } else {
      this.$el.append(noCampaignTemplate({
        i18n,
      }));
      this.perfMarker.done();
    }

    return this;
  }

  validate() {
    //each sub view should provide a validate function
    return _.reduce(_.union([this.settings.validate()], _.map(this.subViews, (subView) => {
      return _.isFunction(subView.validate) ? subView.validate() : true;
    })), (prev, cur) => {
      return prev & cur;
    }, true);
  }

  getValues() {
    const adGroupStored = this.viewModel.adGroup();
    const campaign = this.campaign;
    let adgroup = this.settings.getAdGroup();
    let adgroupSaved = _.has(adGroupStored, 'Id');
    let settings = _.defaults(adgroup, { Campaign: { Id: campaign.Id } });

    if (campaignType() === 'shopping') {
      settings = _.omit(settings, 'Language');
    }

    if (this.options.isDynamicAdGroupCreation) {
      const websiteLanguage = _.chain(this.campaign)
        .result('CampaignSettings')
        .result('0')
        .result('Language')
        .value();

      settings.Language = websiteLanguage;
    }

    //each sub view should provide getValues function
    let params = _.reduce(this.subViews, (memo, value, key) => {
      if (!_.contains(['advanced-settings', 'location-targets', 'cpgBidSection'], key)) {
        _.extend(memo, value.getValues(adgroup.Name, campaign.Name, adgroupSaved ? adGroupStored.Id : undefined));
      }

      return memo;
    }, settings);

    //handling the targets getValues separately
    let deviceTargets = [];
    let locationTargets = [];
    let scheduling = [];

    if (this.subViews['advanced-settings']) {
      let advancedSettingsValues = this.subViews['advanced-settings'].getValues(adgroup.Name, campaign.Name);

      deviceTargets = advancedSettingsValues.deviceTargets;
      scheduling = advancedSettingsValues.scheduling;

      if (!_.isEmpty(advancedSettingsValues.nativeAds)) {
        if (!_.isNull(advancedSettingsValues.nativeAds.NativeBidAdjustment) || adgroupSaved) {
          _.extend(params, advancedSettingsValues.nativeAds);
        }
      }

      if (!_.isEmpty(advancedSettingsValues.multimediaAds)) {
        if (!_.isNull(advancedSettingsValues.multimediaAds.MultimediaAdBidAdjustment) || adgroupSaved) {
          _.extend(params, advancedSettingsValues.multimediaAds);
        }
      }

      _.extend(params, advancedSettingsValues.dateSettings, advancedSettingsValues.netWorkOptions);

      this.hasAdDistribution = !_.isUndefined(params.AdDistribution);
      if (this.hasAdDistribution) {
        this.adDistribution = params.AdDistribution;
        params.AdDistribution = syndEnum.BingYahooAndSearchPartners;
      }
    }

    if (this.subViews['location-targets']) {
      locationTargets = this.subViews['location-targets'].getValues({
        resourceName: 'AdGroupCriterion',
      }, {
        campaignName: campaign.Name,
        adgroupName: adgroup.Name,
      });
    }

    // if current campaign is co-op shopping campaign
    if (this.subViews.cpgBidSection) {
      params = this.getCpgValues(params);
    } else if (campaignType() === 'shopping') { // else if current campaign is standard shopping campaign
      params.ProductPartitions = [{
        ProductCondition: 'All',
        ProductValue: '',
        CampaignName: campaign.Name,
        AdGroupName: adgroup.Name,
        IsExcluded: false,
        IsLeaf: 'Unit',
        Status: 'Active',
        BidAmount: params.SearchBid ? params.SearchBid : defaultBid(),
      }];
    }

    params.AdGroupCriterions = (params.AdGroupCriterions || [])
      .concat(deviceTargets)
      .concat(scheduling)
      .concat(locationTargets.locations || [])
      .concat(locationTargets.intent || [])
      .concat(locationTargets.deletedLocations || []);

    if (campaignType() === 'shopping') {
      params.ProductAds = [{
        CampaignName: campaign.Name,
        AdGroupName: adgroup.Name,
        PromotionalText: '',
      }];
    }

    if (_.has(adGroupStored, 'Id')) {
      params.Id = adGroupStored.Id;
    }

    _.each(params.ResponsiveAds, (responsiveAd) => {
      if (!_.isEmpty(responsiveAd.Headlines)) {
        responsiveAd.Headlines = JSON.stringify(responsiveAd.Headlines);
      }
      if (!_.isEmpty(responsiveAd.LongHeadlines)) {
        responsiveAd.LongHeadlines = JSON.stringify(responsiveAd.LongHeadlines);
      }
      if (!_.isEmpty(responsiveAd.Descriptions)) {
        responsiveAd.Descriptions = JSON.stringify(responsiveAd.Descriptions);
      }
    });

    return params;
  }

  getCpgValues(adgroup) {
    let params = this.subViews.cpgBidSection.getValues(adgroup);

    // For coop adgroup, auto create a root product partition.
    if (!this.defaultProductPartitionCreated) {
      const bidOption = _.result(params.CoOpSetting, 'BidOption');
      const productPartition = _.defaults({
        ProductCondition: 'All',
        ProductValue: '',
        CampaignName: this.campaign.Name,
        AdGroupName: adgroup.Name,
        IsExcluded: false,
        IsLeaf: 'Unit',
        Status: 'Active',
      }, bidOption === 'BidValue' ? {
        BidAmount: adgroup.SearchBid,
      } : {
        BidBoost: _.result(params.CoOpSetting, 'BidBoostValue'),
      });

      params.ProductPartitions = [productPartition];
    }

    return params;
  }

  errorElements() {
    return this.$('.adgroup-create__container .error, .adgroup-create__container .alert-danger').filter(':visible');
  }

  save() {
    if (!this.validate()) {
      scrollUtil.scrollAndCenter(this.errorElements());
      return;
    }

    this.logTrace({
      mes: 'Create ad group in Ad Group Creation Flow',
      adGroupType: this.adGroupType || 'NoSpecified',
    });

    if (this.perfMarker) {
      this.perfMarkerSave = this.perfMarker.createChild('Create_AdGroup_Save');
      this.perfMarkerSave.willInit();
    }

    this.clearApiErrors();

    let params = this.getValues();
    const advancedSettingsView = this.subViews['advanced-settings'];

    if (advancedSettingsView && advancedSettingsView.adScheduleView) {
      params.AdScheduleUseSearcherTimeZone =
        _.result(advancedSettingsView.adScheduleView, 'getAdScheduleUseSearcherTimeZone');
    }

    if (isDSAMixedModeCampaignEnabled) {
      params = _.extend(params, { AdGroupType: this.adGroupType });
    }

    if (isMSStoreAdsGAWorkflow()) {
      params.BiddingScheme.Type = 'InheritFromParent';
    }

    jsData.AdGroup
      .create(params, { adapter: 'bulk', cacheResponse: false })
      .then(this.afterCommitted())
      .then(this.saveImageExtensionsToServer.bind(this))
      .catch(this.apiErrorHandler())
      .finally(uiBlocker(this.el));

    Promise.all(this.deleteSavedEntities())
      .then((response) => {
        if (!_.isEmpty(response)) {
          _.each(this.subViews, (subView) => {
            if (_.isFunction(subView.emptyDeletedItems)) {
              subView.emptyDeletedItems();
            }
          });
        }
        this.activity.stop();
      });
  }

  clearApiErrors() {
    _.each(this.subViews, (view) => {
      if (_.isFunction(view.clearApiErrors)) {
        view.clearApiErrors();
      }
    });
  }

  deleteSavedEntities() {
    const adGroupStored = this.viewModel.adGroup();

    if (!_.has(adGroupStored, 'Id')) {
      return [];
    }

    return _.flatten(_.map(this.subViews, (subView) => {
      if (!_.isFunction(subView.getDeletedItems)) {
        return [];
      }

      return _.map(subView.getDeletedItems(adGroupStored.Id), (item) => {
        return jsData[item.resourceName].destroy(item.Id, { adapter: 'bulk', parentId: item.parentId });
      });
    }));
  }

  saveImageExtensionsToServer() {
    return new Promise((resolve) => {
      const isRSAImageExtInAdGroupCreationEnabled = _.chain(permissions).result('dynamic').result('RSAImageExtInAdGroupCreation').value();

      if (!(isRSAImageExtInAdGroupCreationEnabled && this.adGroupType === 'SearchStandard')) {
        resolve(true);
      }

      const adgroup = this.viewModel.adGroup();

      if (adgroup == null || adgroup.Id == null) {
        resolve(true);
      }

      const adGroupId = parseInt(adgroup.Id, 10);
      const adGroupName = adgroup.Name;
      const adView = this.subViews.ad;

      if (adView == null) {
        resolve(true);
      }

      const cachedImageExtensionChanges = adView.getCachedImageExtensionChanges && adView.getCachedImageExtensionChanges();
      const newI18n = this.options.deps && this.options.deps.i18nNewDesign;

      this.logTrace({
        mes: 'Save image extensions in Ad Group Creation Flow',
        adGroupType: this.adGroupType || 'NoSpecified',
        adGroupId,
        adGroupName,
      });
      const campaign = this.campaign;

      const defaultParams = {
        where: {
          adGroupId,
          adGroupName,
          campaignId: campaign.Id,
          campaignName: campaign.Name,
        },
      };

      if (cachedImageExtensionChanges == null || (_.isEmpty(cachedImageExtensionChanges.added) &&
        _.isEmpty(cachedImageExtensionChanges.removed) && _.isEmpty(cachedImageExtensionChanges.updated))) {
        resolve(true);
      }

      const saveImgsExtPerfMarker = this.perfMarker.createChild('Process_ImageExtensions_Success');

      saveImgsExtPerfMarker.willInit();

      const imageExtRepository = new Repository({
        schema: window.globalLegacySchema.get('ImageAdExtension'),
        afterChangeComitted: () => {
          summaryDataContextManager.updateContext(['AdGroupAdExtensionsGrid']);
        },
      });

      imageExtRepository.association.createRequestFactory('adgroup');

      const createImageExtensionsPromise = _.map(cachedImageExtensionChanges.added, (ext) => {
        return imageExtRepository.extension.create(ext);
      });

      Promise.all(createImageExtensionsPromise)
        .then((newExtensions) => {
          const newExtIds = _.pluck(newExtensions, 'Id');

          this.logTrace({
            mes: 'Saved image extensions in Ad Group Creation Flow',
            adGroupType: this.adGroupType || 'NoSpecified',
            newExtIds,
            adGroupId,
            adGroupName,
          });

          _.each(cachedImageExtensionChanges.added, (item, index) => {
            item.Id = newExtIds[index];
          });

          let deletePromise = Promise.resolve(true);

          if (!_.isEmpty(cachedImageExtensionChanges.removed)) {
            deletePromise =
              imageExtRepository.association.destroyAll({
                where: {
                  id: { in: _.pluck(cachedImageExtensionChanges.removed, 'Id') },
                  ...defaultParams.where,
                },
              });
          }

          return deletePromise
            .then(() => {
              const params = {
                where: {
                  id: { in: newExtIds },
                  ...defaultParams.where,
                },
              };
              const updatePromise = _.map(cachedImageExtensionChanges.updated, (ext) => {
                return imageExtRepository.extension.update(ext);
              });

              return Promise.all(updatePromise).then(() => {
                return imageExtRepository.association.updateAll(null, params);
              });

            });
        })
        .then(() => {
          this.logTrace({
            mes: 'Successfully saved image extensions in Ad Group Creation Flow',
            adGroupType: this.adGroupType || 'NoSpecified',
            adGroupId,
            adGroupName,
          });

          saveImgsExtPerfMarker.done();
          resolve(true);
        })
        .catch((err) => {
          // do nothing, so that this is non-blocking
          this.logTrace({
            mes: 'Saved image extensions with failures in Ad Group Creation Flow',
            adGroupType: this.adGroupType || 'NoSpecified',
            adGroupId,
            adGroupName,
            err,
          });

          const pageName = `<b>${newI18n.getString(_TL_('Ads & extensions'))}</b>`;

          notificationApi.showWarning(newI18n.getString(
            _TL_('There were errors when processing your image extension updates. To ensure that all changes are up to date or to manually create a new image extension, review your image extensions in the {{page}} page.'),
            {
              page: pageName,
            }));
          resolve(true);
        });
    }).catch((err) => {
      this.logTrace({
        mes: 'Create saving image extensions promise with failures in Ad Group Creation Flow',
        adGroupType: this.adGroupType || 'NoSpecified',
        err,
      });
      return Promise.resolve(true);
    });
  }

  afterCommitted() {
    return (adgroup) => {
      this.viewModel.adGroup(_.pick(adgroup, ['Id', 'Name', 'Campaign']));
      if (this.isOpenCreatePanel) {
        const mes = { CampaignId: adgroup.Campaign.Id, DeliveryStatusType: 'NoEligibleAdGroups' };

        this.applyActivity.trace(JSON.stringify(mes));
      }

      this.logCopilotSuggestionMapping(adgroup);

      return this.enableAdGroup()
        .then(() => {
          if (this.perfMarkerSave) {
            this.perfMarkerSave.done({
              campaignType: campaignType(),
            });
          }
          if (this.subViews.bid && this.subViews.bid.searchBidView) {
            activity.signal(JSON.stringify(
              {
                Scenario: 'AdgroupCreation',
                SuggestedBid: this.subViews.bid.searchBidView.viewModel.suggestedBidNew(),
                SaveBid: this.subViews.bid.searchBidView.viewModel.SearchBid(),
                EventName: 'CreationFlowBidSave',
                SuggestedBidRequestId: this.subViews.bid.searchBidView.viewModel.suggestedBidRequestId(),
                CampaignId: this.campaign.Id,
                AdgroupId: adgroup.Id,
                AdGroupLogId,
              },
            ), 'save adgroup Bid');
          }
          if (this.subViews.bid && this.subViews.bid.bidStatusEnabled) {
            logBidAdoption({
              Id: adgroup.Id,
              suggestedBid: this.subViews.bid.suggestedBid,
              isNKW: this.subViews.bid.isNKW,
              SearchBid: adgroup.SearchBid,
              viewedSuggestion: this.subViews.bid.viewedSuggestion,
            }, activity);
          }
          if (_.isArray(adgroup.Keywords) && this.subViews.keyword) {
            this.subViews.keyword.updateViewModels({
              keywords: adgroup.Keywords,
              campaignId: adgroup.Campaign.Id,
              adGroupId: adgroup.Id,
            });
          }
          logAdGroupPersonalizedOffers(this.showCashbackSettings, this.activity.signal.bind(this.activity), adgroup);
          this.navigateToSummaryPage(adgroup);
        })
        .catch((response) => {
          const { errors } = response;

          this.logTrace(response, 'afterCommitted.catch');
          this.backFillEntityIds(adgroup);
          this.viewModel.errors.add(i18nErrors.getBulkApiErrors(errors));
        });
    };
  }

  backFillEntityIds(entity) {
    //hide copy adgroup settings checkbox
    this.settings.copySettings.hide();
    //hide language dropdown
    this.settings.isAfterSave();
    //backFill ads' Ids
    this.subViews.ad && this.subViews.ad.handleAdsError(entity); //eslint-disable-line
    //backFill keywords' Ids
    this.subViews.keyword && this.subViews.keyword.updateViewModels({//eslint-disable-line
      keywords: _.map(entity.Keywords, (keyword) => {
        return _.extend(keyword, {
          AdGroup: { Id: entity.Id },
          Campaign: { Id: entity.Campaign.Id },
        });
      }),
      campaignId: entity.Campaign.Id,
      adGroupId: entity.Id,
      hasErrors: true,
    });
    //backFill targeting's Ids
    if (this.subViews['advanced-settings']) {
      this.subViews['advanced-settings'].setLevel('adgroup');//partial success changes the control mode to edit and level to adgroup
      this.subViews['advanced-settings'].setAdGroupId(entity.Id);
      this.subViews['advanced-settings'].setData(entity);
      this.subViews['advanced-settings'].handleErrors({ entity, errors: {} });
    }
    //refresh location targeting data
    if (this.subViews['location-targets']) {
      this.subViews['location-targets'].setAdGroupId(entity.Id);
      this.subViews['location-targets'].handleApiErrorsForAdGroupLevel(entity.Id);
    }
  }

  apiErrorHandler() {
    return (response) => {
      this.logTrace(response, 'apiErrorHandler');

      if (_.isEmpty(response) || _.isEmpty(response.entity)) {
        //Ajax error [400] - RowCountExceeded
        this.viewModel.errors.add(_.isEmpty(response) || _.isEmpty(response.errors) ? undefined : i18nErrors.getODataErrors(response.errors));

        scrollUtil.scrollAndCenter(this.errorElements());
        return;
      }

      i18nErrors.getPartial(response, ['TextAds', 'AppInstallAds', 'DynamicSearchAds', 'ExpandedTextAds', 'Keywords', 'AdGroupCriterions', 'ProductPartitions', 'ResponsiveSearchAds', 'DsaTargets', 'ResponsiveAds']);

      this.settings.copySettings.hide();

      if (_.isEmpty(response.entity.errors)) {
        // the adgroup passed while sub entities failed
        this.settings.isAfterSave();

        const allAdsAndKeywordsErrors = this.adsAndKeywordsErrors(response.errors);

        if (this.subViews.ad) {
          this.subViews.ad.handleAdsError(response.entity);
        }

        if (this.subViews.keyword) {
          this.subViews.keyword.updateViewModels({
            keywords: _.map(response.entity.Keywords, (keyword) => {
              return _.extend(keyword, {
                AdGroup: { Id: response.entity.Id },
                Campaign: { Id: response.entity.Campaign.Id },
              });
            }),
            campaignId: { Id: response.entity.Campaign.Id },
            adGroupId: { Id: response.entity.Id },
            hasErrors: true,
          });
        }

        if (allAdsAndKeywordsErrors) {
          let allAppealableErrors = true;

          if (this.subViews.ad) {
            allAppealableErrors = allAppealableErrors && this.subViews.ad.allAppealableErrors;
          }
          if (this.subViews.keyword) {
            allAppealableErrors = allAppealableErrors && !this.subViews.keyword.hasChanges();
          }

          if (allAppealableErrors) {
            return this.afterCommitted()(response.entity); //eslint-disable-line
          }
        }

        if (this.subViews['advanced-settings']) {
          this.subViews['advanced-settings'].setLevel('adgroup');//partial success changes the control mode to edit and level to adgroup
          this.subViews['advanced-settings'].setAdGroupId(response.entity.Id);
          this.subViews['advanced-settings'].setData(response);
          this.subViews['advanced-settings'].handleErrors(response);
        }

        if (this.subViews['location-targets']) {
          this.subViews['location-targets'].setAdGroupId(response.entity.Id);
          this.subViews['location-targets'].handleApiErrorsForAdGroupLevel(response.entity.Id);
        }

        if (this.subViews['adgroup-targets']) {
          this.subViews['adgroup-targets'].fillCriterionsWithId(_.result(response.entity, 'AdGroupCriterions'));
        }

        if (_.isArray(response.entity.ProductPartitions)) {
          // When resposne has ProductPartitions entity, it means there is an adgroup trying to be created
          this.defaultProductPartitionCreated = _.isEmpty(_.first(response.entity.ProductPartitions).errors);
        }

        if (this.subViews['auto-targets']) {
          this.subViews['auto-targets'].updateViewModels(response.entity.DsaTargets);
        }

        this.viewModel.adGroup(_.pick(response.entity, ['Id', 'Name', 'Campaign']));
      } else {
        let errors = response.entity.errors;

        if (errors.length && ((errors[0].message && errors[0].message.length === 0) || errors[0].message == null)) { // if message is not converted
          errors = i18nErrors.getODataErrors(response.entity.errors.map((x) => ({ Property: x.property, Code: x.code })));
        }
        this.settings.viewModel.errors.add(errors);
      }

      scrollUtil.scrollAndCenter(this.errorElements());
    };
  }

  adsAndKeywordsErrors(errors) {
    return _.every(errors, (err) => {
      return err.Type === 'Keyword Error' || err.Type.indexOf('Ad Error') > -1;
    });
  }

  enableAdGroup() {
    const campaign = this.campaign;
    const adgroup = this.viewModel.adGroup();
    const params = {
      Id: adgroup.Id,
      Campaign: { Id: campaign.Id },
      Status: 'Active',
    };

    if (this.hasAdDistribution) {
      params.AdDistribution = this.adDistribution;
    }

    this.logTrace({
      mes: 'Created ad group in Ad Group Creation Flow',
      adGroupId: adgroup.Id,
      adGroupType: this.adGroupType || 'NoSpecified',
    });

    return jsData.AdGroup
      .update(adgroup.Id, params, { adapter: 'bulk' });
  }

  cancel() {
    this.navigateToRoute('campaign_adgroup', { 'campaign_id': this.campaign.Id });
  }

  navigateToSummaryPage() {
    this.logTrace('Start navigation', 'navigateToSummaryPage');
    summaryDataContextManager.getContext('/campaign/newadgroup/create?');
    this.navigateToRoute('campaign_adgroup', { 'campaign_id': this.campaign.Id });
    this.eventDelegator.trigger('adGroupReload');
  }

  logTrace(obj, api) {
    let mes = '';

    try {
      mes = JSON.stringify(obj);
    } catch (err) {
      // do nothing
    }

    activity.trace(mes, api);
  }

  remove() {
    if (this.languageLocationConnector) {
      this.languageLocationConnector.stopListening();
    }
    if (this.cpgBidOptionConnector) {
      this.cpgBidOptionConnector.stopListening();
    }
    if (this.bidStrategyBidOptionConnector) {
      this.bidStrategyBidOptionConnector.stopListening();
    }
    if (this.cpgInHouseConnector) {
      this.cpgInHouseConnector.stopListening();
    }
    _.each(this.subViews, (view) => {
      view.remove();
    });

    super.remove();
  }

  logCopilotSuggestionMapping(adgroup) {
    if (campaignType() !== 'search' || this.adGroupType !== 'SearchStandard') {
      return;
    }
    const uniqueId = uuid.v4();
    const campaignId = adgroup.Campaign.Id;
    const accountId = _.get(this.serverContext, ['CurrentAccount', 'Id']);

    const initStatus = {
      Channel: AssetChannel.WEB_UI,
      Feature: AssetEventFeature.RSA,
      Scenario: AssetScenario.CREATE_WORK_FLOW,
      AccountId: accountId,
      UniqueId: uniqueId,
      CampaignId: campaignId,
    };

    const localIds = this.subViews.ad.getAds().map(({ Id }) => Id);
    const realIds = adgroup.ResponsiveSearchAds.map(({ Id }) => Id);

    const data = {
      UniqueId: uniqueId,
      EventName: POST_ASSET_EVENT_NAME,
      EventValue: JSON.stringify({
        ...initStatus,
        Timestamp: new Date().toISOString(),
        RecordType: AssetEventRecordType.MAPPING,
        OperationName: AssetEventOperationName.NON_ITERATIVE,
        RealIds: realIds,
        LocalIds: localIds,
      }),
    };

    this.logTrace(`[PostAssetEventLog]: UniqueId: ${uniqueId}, EventName: ${data.EventName}, EventValue: ${data.EventValue}`);
  }
}
